import { render, staticRenderFns } from "./OpcionesDropdownComponent.vue?vue&type=template&id=ed3d1560&scoped=true"
import script from "./OpcionesDropdownComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OpcionesDropdownComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpcionesDropdownComponent.vue?vue&type=style&index=0&id=ed3d1560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3d1560",
  null
  
)

export default component.exports